import { render, staticRenderFns } from "./InputTags.vue?vue&type=template&id=2e0d8936"
import script from "./InputTags.vue?vue&type=script&lang=js"
export * from "./InputTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports